import { useEffect, useState } from 'react';

import { supabase } from '../lib/supabase';
import { useAppSelector } from '../store/store';

// Se o usuário logado é admin da plataforma. A checagem estava copiada no guard de rota
// (App.tsx) e na Sidebar; com o menu do topo seria a terceira cópia, então virou hook.
//
// Duas fontes, nessa ordem: a flag no JWT resolve na hora e evita ida ao banco; a tabela
// é o fallback para quem virou admin depois do token ter sido emitido.
//
// Serve só para MOSTRAR ou ESCONDER interface. Quem protege os dados é a RLS e a
// verificação de admin dentro de cada edge function — esconder o menu não protege nada.

// A resposta da tabela, guardada por usuário: a próxima tela que perguntar já nasce sabendo.
const conhecidos = new Map<string, boolean>();

const daFlag = (user: { app_metadata?: unknown } | null) =>
  !!((user?.app_metadata || {}) as Record<string, unknown>).is_platform_admin;

/**
 * O admin e se a resposta JÁ CHEGOU. ⚠️ Decisão que barra (a vaga de perfil, 04/11/2026) espera o
 * `conferido`: sem a flag no JWT, a resposta da tabela vem depois do primeiro render, e a tela de
 * criar perfil mandava o admin para os planos antes de saber que ele era admin.
 */
export const useAdminDaPlataforma = (): { isAdmin: boolean; conferido: boolean } => {
  const user = useAppSelector((s) => s.auth.user);
  const deCara = (): boolean | null => (!user ? false : daFlag(user) ? true : conhecidos.get(user.id) ?? null);
  const [isAdmin, setIsAdmin] = useState<boolean | null>(deCara);

  useEffect(() => {
    const ja = deCara();
    setIsAdmin(ja);
    if (ja !== null || !user) return;

    let active = true;
    supabase
      .from('platform_admins')
      .select('id')
      .eq('user_id', user.id)
      .maybeSingle()
      .then(({ data, error }) => {
        // Troca de usuário no meio da consulta não pode aplicar o resultado do anterior.
        if (!active) return;
        if (!error) conhecidos.set(user.id, !!data);
        setIsAdmin(!!data);
      });

    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return { isAdmin: !!isAdmin, conferido: isAdmin !== null };
};

export const useIsPlatformAdmin = (): boolean => useAdminDaPlataforma().isAdmin;
